export const EVENT_UPDATED = 'Event details updated.';
export const EVENT_DELETED = 'Events deleted.';
export const EVENT_CREATED = 'Event created.';
export const EVENT_DUPLICATED = 'Event duplicated successfully.';
export const EVENT_DUPLICATE_ERROR = 'Unable to duplicate event.';
export const MEMBERBODY_REQUIRED = 'Please select an Event Organizer first.';
